// extracted by mini-css-extract-plugin
module.exports = {"industryGrid":"industry-grid-module--industryGrid--79NEc","industryGridItem":"industry-grid-module--industryGridItem--3LPaK"};